<template>
  <div class="client-sub card card--transparent">
    <h2 style="text-align: center">Subscription</h2>
    <div class="small-top">
      <div class="space-between" v-if="!subscription.canceled">
        <span>Next Billing Date: {{invoiceAt}}</span>
        <a @click="cancelSub">Cancel Subscription</a>
      </div>
      <div class="space-between" v-else>
        <span>Your account expires on: {{invoiceAt}}</span>
      </div>
      <!-- <div class="space-between small-top">
        <span>Card Used: xxx xxxxx xxxx 4111</span>
        <a>Update Card</a>
      </div> -->
    </div>
    <modal 
      title="Canceled Subscription" 
      btn="Close"
      @close="show = false"
      @submit="show = false"
      v-if="show">
      Your subscription has been canceled. 
      <div>Your account will expire on: <b>{{invoiceAt}}</b></div>
      </modal>
  </div>
</template>

<script>
import dataStore from "@/services/api/store";
import modal from "@/components/modal/default";
import moment from "moment";

const CLIENT_SUBSCRIPTION_STORE = "ClientSubscription";

export default {
  props: ["subscription"],
  components: { modal },
  data() {
    return {
      show: false
    }
  },
  methods: {
    cancelSub() {
      dataStore.destroy(CLIENT_SUBSCRIPTION_STORE, this.subscription.id)
        .then(() => {
          this.subscription.canceled = true;
          this.show = true;
        })
    }
  },
  computed: {
    invoiceAt() {
      return moment(this.subscription.scheduled_invoice_at).format('MMM D, YYYY')
    }
  }
}
</script>

<style lang="less">
.client-sub {
  a {
    text-decoration: underline;
  }
}
</style>